import "./GetInvolved.module.css";
import Header from "@/reusable_sections/Header";
import WaysToGive from "./sections/WaysToGive";
import CorporatePartnerships from "./sections/CorporatePartnerships";
import Footer from "@/reusable_sections/Footer";
export default function GetInvolvedPage() {
  return <div>
      <Header />
      <WaysToGive />
      <CorporatePartnerships />
      <Footer />
    </div>;
}